import React from 'react';
import { Provider } from 'react-redux';
import { RelayEnvironmentProvider } from 'react-relay';
import { Environment } from 'relay-runtime';

import AccessContainer from './components/AccessContainer';
import GantCalendarLoader from './gant/gantCalendarLoader';
import { store } from './store';
import { TaskBoardColumnsLoader } from './taskBoard/component/taskBoardColumnsLoader';
import { TaskBoardWrapper } from './taskBoard/taskBoardWrapper';

interface OutTaskBoardProps {
    paddingBottom?: number;
    marginTop?: number;
    environment?: Environment;
    onFinishLoadData?: () => void;
    authorId: string;
}

const OutTaskBoard: React.FC<OutTaskBoardProps> = ({
    paddingBottom,
    marginTop,
    environment,
    onFinishLoadData,
    authorId,
}) => {
    const TaskBoardComponent = (
        <AccessContainer accessFor={['schedule-task']} isAlert>
            <GantCalendarLoader authorId={authorId} />
            <TaskBoardColumnsLoader onFinishLoadData={onFinishLoadData} />
            <TaskBoardWrapper paddingBottom={paddingBottom} marginTop={marginTop} />
        </AccessContainer>
    );

    return (
        <Provider store={store}>
            {environment ? (
                <RelayEnvironmentProvider environment={environment}>{TaskBoardComponent}</RelayEnvironmentProvider>
            ) : (
                TaskBoardComponent
            )}
        </Provider>
    );
};

export default OutTaskBoard;
